import 'lightgallery/scss/lightgallery.scss'
import 'lightgallery/scss/lg-thumbnail.scss'
import css from './Gallery.module.scss'
import React, { useRef, useState } from 'react'
import { LightGallery as ILightGallery } from 'lightgallery/lightgallery'
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import LightGallery from 'lightgallery/react'

import { FeaturePhotoPoint } from 'meta/photo/photoPoint'

import { GalleryProps } from 'client/components/Gallery/props'

import { useGalleryItems } from './hooks/useGalleryItems'
import { useOnBeforeSlide } from './hooks/useOnBeforeSlide'
import { useOnInit } from './hooks/useOnInit'

const licenseKey = import.meta.env.VITE_LIGHT_GALLERY_KEY

type Props = GalleryProps & { galleryKey: string }

const Gallery: React.FC<Props> = (props) => {
  const { galleryKey, photoPoints } = props

  const [galleryContainer, setGalleryContainer] = useState<HTMLDivElement | null>()
  const lightGalleryRef = useRef<ILightGallery>(null)
  const activePhotoPointRef = useRef<FeaturePhotoPoint>(photoPoints.at(0))

  const galleryItems = useGalleryItems({ photoPoints })
  const onInit = useOnInit({ lightGalleryRef })
  const onBeforeSlide = useOnBeforeSlide({ photoPoints, activePhotoPointRef })

  return (
    <div className={css.gallery} ref={setGalleryContainer}>
      <div className={css.story}>{activePhotoPointRef.current?.properties?.storyName}</div>
      {galleryContainer && (
        <LightGallery
          closable={false}
          container={galleryContainer}
          controls
          download={false}
          dynamic
          dynamicEl={galleryItems}
          key={galleryKey}
          licenseKey={licenseKey}
          mobileSettings={{ controls: true }}
          onBeforeSlide={onBeforeSlide}
          onInit={onInit}
          plugins={[lgThumbnail]}
          preload={photoPoints.length}
        />
      )}
    </div>
  )
}

export default Gallery
